const initialState = {
  currentRouteKey: '',
  session: '',
  layoutType: 'single',
  previousLayoutType: '',
  productCols: 2,
  token: '',
  secure: false,
  inIframe: false,
  user: {},
  configs: {},
  liquidAnalytics: {},
  loading: true,
  productionReady: false,
  liquidToken: '',
  element: '',
  view: 'desktop',
  dynamicStyles: {
    container: '925px',
    grid: '2',
    seeMore: 'blur-[14px]'
  },
  bg: '',
  env: {
    staging: [''],
    production: '',
    allowLocal: true,
    live: false
  }
}

export default initialState
